import { Component, OnInit } from '@angular/core';

import { NotificationsService } from '../notifications.service';

@Component({
  selector: 'lib-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  constructor( public notifications: NotificationsService ) { }

  ngOnInit() {
  }

}
